import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';
import LanguageSelector from '../components/ui/LanguageSelector';

/**
 * Auth Layout for Login/Registration Pages
 * Includes logo, language selector, and consistent styling
 */
const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex flex-col">
      {/* Header with Logo and Language Selector */}
      <header className="w-full py-4 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-amber-400 rounded-lg flex items-center justify-center">
              <Icon name="Car" size={20} className="text-gray-900" />
            </div>
            <span className="text-xl font-semibold text-gray-900">Phangan Taxi</span>
          </Link>

          {/* Language Selector */}
          <LanguageSelector />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-4">
        {children}
      </main>
    </div>
  );
};

export default AuthLayout;